export interface UserForm {
  municipality_id: string
  name: string
  username: string
  email: string
  password: string
  password_confirmation: string
  roles: string[]
  position: string
}

export const initialValues: UserForm = {
  municipality_id: '',
  name: '',
  username: '',
  email: '',
  password: '',
  password_confirmation: '',
  roles: [],
  position: '',
}
